const ratings = {
  title: "Bewerte den Auftragnehmer",
  info: "Deine Meinung ist uns wichtig. Was hältst du von dem abgeschlossenen Auftrag?",
  unhappy: "Unzufrieden",
  happy: "Zufrieden",
  comment: "Zusätzliche Informationen (optional)",
  error: "Wähle eine Bewertung, um fortzufahren.",
  companyRatings: "Firmenbewertungen",
  noComment: "Kein Kommentar",
  noRatings: "Keine Bewertungen",
};

export default ratings;
